import app from '../../app';
import { Store } from 'redux';
import { IAppState } from '../../../../../shared/redux';
import { validateVisibleViolations } from '../../../../../shared/services/validateVisibleViolations';
import { IHttpApi } from '@cian/http-api/shared';
import { selectSkipHash } from '../../../../../shared/selectors/visibleViolations';
import { IValidateVisibleViolationsRequest } from '../../../../../shared/repositories/monolith-python/v2/validate-visible-violations';
import { IOfferState } from '../../../../../shared/redux/reducers';
import { selectConfigValue } from '../../../../../shared/selectors/config';

export function publishOfferService(store: Store<IAppState>, httpApi: IHttpApi) {
  const checkVisibleViolations = (offer: IOfferState, isPremoderationSkip: boolean) => {
    const state = store.getState();

    const subdomain = selectConfigValue('subdomain', state);
    const skipHash = isPremoderationSkip ? selectSkipHash(state) : null;

    const parameters = offer as unknown as IValidateVisibleViolationsRequest;

    return validateVisibleViolations({ httpApi, parameters, subdomain, skipHash });
  };

  return {
    checkVisibleViolations,
  };
}

app.service('publishOfferService', ['store', 'httpApi', publishOfferService]);
